import { ContentService } from "@Api/ContentService";
import { SubscriptionBase } from "@Base/Engagement/SubscriptionBase";

export class FooterBase
{
	private readonly contentService: ContentService;
	public FooterForm: HTMLFormElement;
	public Subscription: SubscriptionBase;

	constructor()
	{
	}

	public Initialize(): void
	{
	}

	public ConfigureSubscription(): void
	{
	};

	private DisplaySellDataOptOutLink = (): void =>
	{
		const sellLink = document.querySelector("#jsSellInfo");

		if (sellLink !== null)
		{
			sellLink.classList.remove("d-none");
			sellLink.classList.add("d-block");
		}
	};

	public TriggerContentCallbacks = (): void =>
	{
		this.FooterForm = document.getElementById("frmSubscribe") as HTMLFormElement;

		if (this.FooterForm !== null)
		{
			this.ConfigureSubscription();
		}

		if (typeof ContentService.Response !== "undefined")
		{
			if (ContentService.Response.DisplaySellDataOptOutLink)
			{
				this.DisplaySellDataOptOutLink();
			}
		}
	};
}